import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AppContext } from '../../../context/AppContext';
import Login from '../../../subscreen/patient/patientauth/Login';
import JoinAsDoctor from '../../../subscreen/doctor/doctorauth/JoinAsDoctor';
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../assets/css/patient/MyNavbar.css';

const SpeechBubbleLogo = () => (
  <svg width="38" height="38" viewBox="0 0 100 100" style={{ display: 'block' }}>
    <circle cx="50" cy="50" r="48" fill="#00005a"/>
    <circle cx="50" cy="48" r="32" fill="#FF6F00"/>
    <circle cx="50" cy="48" r="22" fill="#FFFFFF"/>
    <path d="M 38 70 L 30 82 L 48 74 Z" fill="#FF6F00"/>
  </svg>
);

export default function Navbar() {
  const [isJoinAsDoctorOpen, setIsJoinAsDoctorOpen] = useState(false);
  const [isLoginModalOpen, setIsLoginModalOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);
  const profileMenuRef = useRef(null);

  const { isLoggedIn, user, logout } = useContext(AppContext);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (profileMenuRef.current && !profileMenuRef.current.contains(e.target)) {
        setIsProfileMenuOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // Screen bara hone par mobile menu band kar do (warna state atak jata hai)
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 991) setIsMobileMenuOpen(false);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleLoginClick = () => {
    closeMobileMenu();
    setIsLoginModalOpen(true);
  };

  const handleJoinClick = () => {
    closeMobileMenu();
    setIsJoinAsDoctorOpen(true);
  };

  const handleLogout = () => {
    setIsProfileMenuOpen(false);
    closeMobileMenu();
    logout();
    navigate('/');
  };

  const getInitials = (name) => {
    if (!name) return "P";
    return name.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase();
  };

  return (
    <>
      <nav className={`navbar ${isScrolled ? 'scrolled' : ''}`}>
        <div className="container">

          <Link to="/" className="navbar-brand" onClick={closeMobileMenu}>
            <SpeechBubbleLogo />
            <span className="brand-text">
              Smart<span className="brand-highlight">Therapy</span>
            </span>
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            aria-label="Toggle navigation"
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          {/* Links + buttons ab ek hi wrapper mein hain -> mobile par dono
              menu ke andar stack hote hain, koi overlap nahi hota */}
          <div className={`navbar-menu ${isMobileMenuOpen ? 'show' : ''}`}>

            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link" to="/" onClick={closeMobileMenu}>Home</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/doctors" onClick={closeMobileMenu}>Therapists</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/about" onClick={closeMobileMenu}>About</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/blog" onClick={closeMobileMenu}>Blog</Link>
              </li>
            </ul>

            <div className="navbar-buttons">
              {!isLoggedIn ? (
                <>
                  <button className="btn-doctor" onClick={handleJoinClick}>
                    <span>Join as Therapist</span>
                  </button>
                  <button className="btn-login" onClick={handleLoginClick}>
                    Login / Signup
                  </button>
                </>
              ) : (
                <div className="navbar-right-logged-in">
                  <button
                    className="notif-bell-btn"
                    onClick={() => {
                      closeMobileMenu();
                      navigate('/patientdashboard/mynotifications');
                    }}
                    title="Notifications"
                  >
                    <i className="fa-regular fa-bell"></i>
                  </button>

                  <div className="profile-menu-wrapper" ref={profileMenuRef}>
                    <button
                      className="profile-menu-trigger"
                      onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
                    >
                      <span className="profile-avatar">{getInitials(user?.name)}</span>
                      <span className="profile-name">{user?.name?.split(' ')[0] || 'Patient'}</span>
                      <i className={`fa-solid fa-chevron-down profile-chevron ${isProfileMenuOpen ? 'open' : ''}`}></i>
                    </button>

                    {isProfileMenuOpen && (
                      <div className="profile-dropdown">
                        <Link
                          to="/patientdashboard/profile"
                          className="profile-dropdown-item"
                          onClick={() => { setIsProfileMenuOpen(false); closeMobileMenu(); }}
                        >
                          <i className="fa-solid fa-user"></i> Profile
                        </Link>
                        <Link
                          to="/patientdashboard/mysettings"
                          className="profile-dropdown-item"
                          onClick={() => { setIsProfileMenuOpen(false); closeMobileMenu(); }}
                        >
                          <i className="fa-solid fa-gear"></i> Settings
                        </Link>
                        <button className="profile-dropdown-item logout-item" onClick={handleLogout}>
                          <i className="fa-solid fa-arrow-right-from-bracket"></i> Logout
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

          </div>
        </div>
      </nav>

      <Login isOpen={isLoginModalOpen} onClose={() => setIsLoginModalOpen(false)} />
      <JoinAsDoctor isOpen={isJoinAsDoctorOpen} onClose={() => setIsJoinAsDoctorOpen(false)} />
    </>
  );
}